export default {
    path : "warehouse-item-focus",
    name : "warehouse-item-focus",
    meta : {
        title : "关注项目"
    },
    component: () => import('@/pages/warehouse/focus/Index'),
    redirect: {
        name : "warehouse-item-focus-whole"
    },
    children: [
        {
            path: 'all',
            name: 'warehouse-item-focus-whole',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'recent',
            name: 'warehouse-item-focus-recent',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'atme',
            name: 'warehouse-item-focus-atme',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'meat',
            name: 'warehouse-item-focus-meat',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'reply',
            name: 'warehouse-item-focus-reply',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'search',
            name: 'warehouse-item-focus-search',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
        {
            path: 'update',
            name: 'warehouse-item-focus-update',
            meta: {
                title: '仓库项目-列表页'
            },
            component: () => import('@/pages/itemCommon/List'),
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/warehouse/focusitem/index.js